// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedAttendanceStatus {
  absent: {"enum_constant":"absent"};
  complete: {"enum_constant":"complete"};
  partial: {"enum_constant":"partial"};
}

export type AttendanceStatusId = keyof IParsedAttendanceStatus;
export type AttendanceStatusData = IParsedAttendanceStatus[AttendanceStatusId];
const data: AttendanceStatusData[] = [{"enum_constant":"absent"},{"enum_constant":"complete"},{"enum_constant":"partial"}];
export default data;
